import { Switch } from "antd";
import React from "react";

export default function Toggle({ rememberMe, setData }) {
  return (
    <div className="flex items-center">
      {/* <input
        type="checkbox"
        id="hs-basic-with-description-unchecked"
        className="relative shrink-0 w-[2.25rem] h-5 bg-gray-400 checked:bg-none checked:bg-blue-600 border-[1.5px] md:border-[0px] border-l-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 border-transparent ring-1 ring-transparent  ring-offset-white focus:outline-none appearance-none before:inline-block before:w-4 before:h-4 before:bg-white checked:before:bg-blue-200 before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200   before:top-0"
      /> */}
      <Switch
        size="medium"
        checked={rememberMe}
        style={{ backgroundColor: rememberMe ? "#1677ff" : "grey" }}
        onClick={() => {
          setData((data) => ({ ...data, rememberMe: !data.rememberMe }));
        }}
      />
      <label
        htmlFor="hs-basic-with-description-unchecked"
        className="text-sm text-gray-500 ml-3 "
      >
        Remember me
      </label>
    </div>
  );
}
